import _ from 'lodash';

import { companies } from 'config/companies';
import {
  Baseline,
  BaselinesData,
  MODE,
  SHIFT,
  WorkCenterBaseline
} from 'models/baselines';
import { WorkCenter } from 'models/workcenters';

export const showRequestedBaselines = (
  baseline: WorkCenterBaseline,
  selectionChangeAll: {
    isSelected: boolean;
  }
) => {
  if (
    !selectionChangeAll.isSelected ||
    (selectionChangeAll.isSelected &&
      baseline.requested &&
      baseline.requested.length > 0)
  ) {
    return true;
  }
  return false;
};

export const getBaselineTotal = (baselines: Baseline[], shift: SHIFT) => {
  return _.chain(baselines)
    .flatMap((value) => {
      return shift === SHIFT.DAY ? value.day : value.night;
    })
    .reduce((sum, n) => {
      return sum + n;
    }, 0)
    .value();
};

export const getCompanyNameFromId = (companyId: string): string => {
  const foundCompany = companies.filter(
    (company) => company.id.toLowerCase() === companyId.toLowerCase()
  );
  return foundCompany.length ? foundCompany[0].name : 'No matching company ID';
};

export const getWorkCentersWithSearchedWorkCenter = (
  fullBaselineData: WorkCenterBaseline[],
  lowerCaseSearchTerm: string
) => {
  return fullBaselineData.filter((baseline) => {
    return baseline.workCenter.toLowerCase().includes(lowerCaseSearchTerm);
  });
};

export const getWorkCentersWithSearchedCompany = (
  fullBaselineData: WorkCenterBaseline[],
  lowerCaseSearchTerm: string,
  companyId: string,
  workCenter: WorkCenter
) => {
  const associatedCompanyId = companyId.toLowerCase();
  const filteredBaselines: WorkCenterBaseline[] = [];
  if (
    associatedCompanyId.includes(lowerCaseSearchTerm) ||
    getCompanyNameFromId(companyId).toLowerCase().includes(lowerCaseSearchTerm)
  ) {
    fullBaselineData.forEach((baseline) => {
      if (baseline.workCenter === workCenter.workCenter) {
        filteredBaselines.push(baseline);
      }
    });
  }

  return filteredBaselines;
};

export const insertCompanyName = (baselines: Baseline[]) => {
  return baselines.map((baseline) => {
    const companyName = companies.filter(
      (company) => company.id.toLowerCase() === baseline.companyId.toLowerCase()
    );

    return companyName.length > 0
      ? { ...baseline, companyName: companyName[0].name }
      : { ...baseline };
  });
};

export const addWorkCentersWithoutBaseline = (
  workCenters: WorkCenter[],
  baselines: BaselinesData[]
) => {
  if (workCenters.length && baselines.length) {
    const wcList = _.cloneDeep(workCenters);
    const baselinesList = _.cloneDeep(baselines) as WorkCenterBaseline[];
    if (wcList.length > 0) {
      wcList.forEach((item) => {
        const baselineWorkCenterIndex = baselinesList.findIndex(
          (wc) => wc.workCenter === item.workCenter
        );

        if (baselineWorkCenterIndex === -1) {
          baselinesList.push({
            id: null,
            workCenter: item.workCenter,
            isSelected: false,
            description: item.description,
            mode: MODE.NONE,
            approved: [],
            requested: []
          });
        } else {
          const workCenterWithBaseline = baselinesList.slice(
            baselineWorkCenterIndex
          )[0];
          baselinesList.splice(baselineWorkCenterIndex, 1, {
            ...workCenterWithBaseline,
            description: item.description,
            mode: MODE.NONE,
            isSelected: false
          });
        }
      });

      return _.sortBy(baselinesList, ['workCenter']);
    }
  }
  return [];
};

export const getFulfilledResponse = (
  results: PromiseSettledResult<Response>[]
) => {
  return results
    .filter((result) => {
      return result.status === 'fulfilled';
    })
    .map((result) => {
      const fulfilledResult = result as PromiseFulfilledResult<Response>;
      return fulfilledResult.value.status;
    });
};
